module.exports = __webpack_public_path__ + "img/5-1.5ed3e720.svg";